// extracted by mini-css-extract-plugin
export default {"list":"style_list__kIN5c","item":"style_item__auwiz"};